import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAngleLightDown = (props) => /* @__PURE__ */ _jsx("svg", {
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M19.018 20.802 5.615 7.192a1.388 1.388 0 0 1 0-1.964l.82-.82a1.388 1.388 0 0 1 1.965 0L20 16.226 31.6 4.419a1.388 1.388 0 0 1 1.964 0l.82.82a1.388 1.388 0 0 1 0 1.964l-13.402 13.61a1.398 1.398 0 0 1-1.964-.01Zm1.964 14.79L34.385 21.98a1.388 1.388 0 0 0 0-1.964l-.82-.82a1.388 1.388 0 0 0-1.965 0L20 31.015 8.4 19.208a1.388 1.388 0 0 0-1.964 0l-.82.82a1.388 1.388 0 0 0 0 1.964l13.402 13.61a1.398 1.398 0 0 0 1.964-.01Z" })
});
export default SvgAngleLightDown;
